<script setup>
import Modal from "../../../../components/ui-components/modal/Modal.vue";
import { ref, defineExpose, onMounted } from "vue";
import {useRoute, useRouter} from 'vue-router'
import { useCookies } from 'vue3-cookies'

const route = useRoute()
const router = useRouter()

const { cookies } = useCookies();

const baseModal = ref(null);
const resolvePromise = ref(null);

const show = () => {
  baseModal.value.open();
};

const init = () => {
}

const cancel = () => {
  baseModal.value.close();
};

defineExpose({
  show,
  cancel,
  init,
})
</script>
<template>
  <Modal ref="baseModal" class="vld-parent">
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body">
        <h2>[아르바이트 공고] 반도체아카데미 교육 운영 보조 (단기 아르바이트) (0명)</h2>
        <div class="gray-container">
          📋 주요업무<br/>
          반도체 아카데미 교육과정 운영 지원<br/>
          강의장 세팅 및 정리<br/>
          수강생 출결 및 현장 관리<br/>
          교육 운영 관련 행정 보조<br/>
          아카데미 행사 및 현장 운영 지원<br/>
          기타 협회 요청 업무 대응<br/><br/><br/>

          📋 자격요건<br/>
          경력 무관 (신입 지원 가능)<br/>
          대학교 재학(4년제) 이상, 졸업예정자 지원 가능<br/>
          7/6~8/28 기간동안 근무 가능한 자(근무 기간은 협의에 따라 일부 조정 가능, 월~금 근무, 주말/공휴일 휴무)<br/>
          평일 09:00 ~ 18:00 근무 가능자<br/>
          현장 운영 업무 수행에 무리가 없는 자<br/>
          책임감 있게 근무 가능한 자<br/><br/><br/>

          📋 우대사항<br/>
          반도체아카데미 오프라인 교육 수료자<br/>
          학원/교육기관 보조강사 또는 운영 보조 경험자<br/>
          과제 첨삭, 학습 관리 등 교육 관련 아르바이트 경험자<br/>
          유사 교육 프로그램 운영 경험자<br/><br/><br/>

          🏠 근무조건<br/>
          고용형태: 아르바이트<br/>
          급여: 시급 13,000원 (주휴수당 별도)<br/>
          근무지: 경기 성남시 분당구 대왕판교로 712번길, 22 (글로벌 R&D 센터) , 판교역에서 출/퇴근 셔틀 운행<br/><br/><br/>

          🚀 채용절차<br/>
          접수기간: 2026-06-26 10시 ~ 2026-07-02 17시<br/>
          제출서류: 자유양식의 이력서 1부 (첨부파일 양식 참고)<br/>
          접수방법: academy@ksia.or.kr 로 이메일 지원<br/>
          전형절차: 서류전형 → 대면 면접 → 최종합격<br/><br/><br/>

          🔔 유의사항<br/>
          입사지원 서류에 허위사실이 발견될 경우, 채용확정 이후라도 채용이 취소될 수 있습니다.<br/>
          근무 중 교육 장소에 따라 근무지가 변경될 수 있습니다. (경기도 소재)<br/><br/><br/>

          문의 : Q&A 게시판 또는 031-622-7677 전화문의 (오전 9시~오후6시)
        </div>
      </div>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
@import "../../../../assets/scss/theme";

.modal-inner {
  .gray-container {
    max-height: 70vh;
    overflow-y: auto;
    background: $gray-light_color;
    text-align: left;
    padding: 20px;
    margin-top: 20px;
  }
  .modal-footer {
    display: block;
  }
}
</style>